import React, { useState } from "react";
import "../Dashboard/dashboard.css";
import Leftbar from "../../components/Leftsidebar";
import moment from "moment";
import Topbar from "../../components/Topbar";
const Dashboard = () => {
  const [showSidebar, setShowSidebar] = useState(false);


  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  return (
    <>
      <div class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose}
          />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div className="header bg-color pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <h6 className="h6 text-white d-inline-block mb-0">
                        Dashboard
                      </h6>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card card-stats card-style h-100">
                        <div className="card-body">
                          <h6 className="card-title text-uppercase text-white mb-0">creator</h6>
                          <span className="h6 font-weight-bold mb-0 text-white">500.00</span>
                          <div className="col-auto mt-2">
                            <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                              <i className="ni ni-active-40" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card card-stats card-style h-100">
                        <div className="card-body">
                          <h6 className="card-title text-uppercase text-white mb-0">business</h6>
                          <span className="h6 font-weight-bold mb-0 text-white">10</span>
                          <div className="col-auto mt-2">
                            <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                              <i className="ni ni-active-40" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card card-stats card-style h-100">
                        <div className="card-body">
                          <div className="card-title text-uppercase text-white mb-0">
                            invoice{" "}
                            <span className="font-weight-bold h6 text-white">({moment(new Date()).format("MMM YYYY")})</span>
                          </div>
                          <span className="h6 font-weight-bold mb-0 text-white">20</span>
                        </div>
                      </div>
                    </div>


                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card card-stats card-style h-100">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-white mb-0">contract</h6>
                              <span className="h6 font-weight-bold mb-0 text-white">10</span>
                            </div>
                            <div className="col-auto">
                              <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                                <i className="ni ni-active-40" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="row" style={{ marginTop: "15px" }}>
                    <div className="col-xl-6 col-md-6 mb-2">
                      <div className="card card-stats card-style">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              <h6 className="card-title text-uppercase font-weight-bold mb-0 text-white">

                                gigs (1)
                              </h6>

                            </div>
                          </div>
                          <div className="row mt-3 align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-white mb-0">
                                Total Earnings :
                              </h6>
                            </div>
                            <div className="col text-right">
                              <span className="h6 font-weight-bold mb-0 text-white">300.00</span>
                            </div>
                          </div>
                          <div className="row mt-3 align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-white mb-0">
                                courses :
                              </h6>
                            </div>
                            <div className="col text-right">
                              <span className="h-6 font-weight-bold mb-0 text-white">

                                0
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-md-6 mb-2">
                      <div className="card card-stats card-style">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              <h6 className="card-title text-uppercase font-weight-bold mb-0 text-white">
                                {/* Doula ({Doula.count}) */}
                                shows (0)
                              </h6>
                            </div>
                            <div className="col text-right">
                              <span className="h6 font-weight-bold mb-0 text-white">
                                {/* ({Doula.count}) */}
                                (0)
                              </span>
                            </div>
                          </div>
                          <div className="row mt-3 align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-white mb-0">
                                Total Earnings :
                              </h6>
                            </div>
                            <div className="col text-right">
                              <span className="h6 font-weight-bold mb-0 text-white">2000.00</span>
                            </div>
                          </div>
                          <div className="row mt-3 align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-white mb-0">
                                Total Bookings :
                              </h6>
                            </div>
                            <div className="col text-right">
                              <span className="h6 font-weight-bold mb-0 text-white">
                                {/* {Doula.bookings} */}
                                0
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
export default Dashboard;